import { Injectable } from '@angular/core';
import {jwtDecode, JwtPayload}  from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class TokenVerificationService {
  private jwtToken: string | null = null;
  private decodedToken: JwtPayload | null = null;

  constructor() {}

  private decodeToken(): void {
    try {
      if (this.jwtToken) {
        this.decodedToken = jwtDecode(this.jwtToken);
      }
    } catch (e) {
      this.decodedToken = null;
    }
  }

  public setToken(token: string): void {
    if (token) {
      this.jwtToken = token;
    }
  }

  public getToken(): string | null {
    return this.jwtToken;
  }


  public getDecodedToken(): JwtPayload | null {
    return this.decodedToken;
  }

  public getExpiryTime(): number | null {
    this.decodeToken();
    return this.getDecodedToken()?.exp ?? null;
  }

  /**
   * Checks if the token is expired based on a provided duration in milliseconds.
   */
  public isTokenExpired(): boolean | null {
    const expiryTime = this.getExpiryTime();

    if (expiryTime) {
      const now = Date.now(); // current time in ms
      const tokenExpiryInMs = expiryTime * 1000; // exp is in seconds

      const remaining = tokenExpiryInMs - Date.now();
      const daysLeft = Math.floor(remaining / (1000 * 60 * 60 * 24));
      // console.log(`Token valid for ${daysLeft} more days.`);

      return tokenExpiryInMs < now;
    }

    return null;
  }
}
